module.exports = __webpack_public_path__ + "images/pr_concentra_logo.jpg";